export default "__VITE_ASSET__S01Cemim__"